
export const routeGenerator = (routes, currentPath) => {
    const splitRoute = window.location.href.split('/').filter(path => path);

    const currentRouteObject = routes
        ?.find(route => route.aplicaciones
            ?.some(app => splitRoute?.includes(app.pagina)));

    const currentRouteApplication = currentRouteObject
        ?.aplicaciones
        ?.find(app => splitRoute?.includes(app?.pagina));

    const showBackArrow = currentPath?.pathname !== currentRouteApplication?.url;

    return {
        breadcrumbs: [
            currentRouteObject?.descripcion,
            showBackArrow ? currentRouteApplication?.descripcion : '',
            showBackArrow ? currentRouteApplication?.descripcionConParam : '',
        ],
        showBackArrow
    }
}